import { ANALYTICS_EVENTS, APP_STORE_URLS, MARKET, PLAY_STORE_URLS } from '@nandosaus/constants';
import styled from 'styled-components';

import { analytics } from '../../analytics';
import { breakpoints } from '../../constants';
import { Container, Flex } from '../grid';
import { P } from '../typography/new';
import { Link } from '../link';
import { useMarket } from '../../hooks/use-market';

const PeriPerksAppStore = () => {
  const market = useMarket();
  const isNzMarket = market === MARKET.NEW_ZEALAND;

  const APP_STORE_URL = isNzMarket ? APP_STORE_URLS.NZ : APP_STORE_URLS.AU;
  const GOOGLE_PLAY_URL = isNzMarket ? PLAY_STORE_URLS.NZ : PLAY_STORE_URLS.AU;

  return (
    <Container mt={{ xs: '72px', md: '104px' }} mb={{ xs: '28px', md: '40px' }}>
      <Flex flexDirection="column" alignItems="center" textAlign="center" gap="27px">
        <Flex gap="24px">
          <Link
            href={APP_STORE_URL}
            target="_blank"
            onClick={() => analytics.track(ANALYTICS_EVENTS.APPLICATION_INSTALL_CLICKED, { store: 'Apple' })}
          >
            <AppBadge alt="app-store-badge" src="static/images/peri-perks/app-store-badge.svg" />
          </Link>

          <Link
            href={GOOGLE_PLAY_URL}
            target="_blank"
            onClick={() => analytics.track(ANALYTICS_EVENTS.APPLICATION_INSTALL_CLICKED, { store: 'Google Play' })}
          >
            <AppBadge alt="google-play-badge" src="static/images/peri-perks/google-play-badge.svg" />
          </Link>
        </Flex>

        <P variant="extra-small" width="100%" maxWidth="752px">
          Make sure you stay opted in to receive communications from us to gain access to all the Perks mentioned above,
          including your freebies and invites to our exclusive member events.
        </P>
      </Flex>
    </Container>
  );
};

const AppBadge = styled.img`
  height: 50px;

  @media (min-width: ${breakpoints.md}) {
    height: 54px;
  }
`;

export { PeriPerksAppStore };
